import { render, staticRenderFns } from "./CreateBanner.vue?vue&type=template&id=ccf7aeb8&scoped=true&"
import script from "./CreateBanner.vue?vue&type=script&lang=js&"
export * from "./CreateBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf7aeb8",
  null
  
)

export default component.exports